import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { map, filter, compose, min } from 'lodash/fp';
import moment from 'moment';
import { actions as appointmentActions } from './actions/actions';
import { actions as practiceActions } from '../actions/actions';
import { actions as filterActions, filterTypes } from './actions/filterActions';
import { actions as pageActions } from './actions/pageActions';
import { actions as patientSelectionActions } from 'vAppointment/PatientSelection/actions/actions';
import { DoctorProfilePropType, SelectedTimePropType } from './propTypes';
import DoctorContainer from './DoctorContainer';
import DatePickerComponent from './DatePicker';
import LoadingSpinner from '../../components/loadingSpinner';
import Header from '../../components/UIContainer/MobileUI/header';
import { actions as profileActions } from 'components/UIContainer/MobileUI/MainShell/actions/profileActions';
import { clearAppointmentData } from '../../selectors/appointmentSelectors';
import EmptyBookings from './EmptyBookings';
import styles from './bookingPageMobile.module.css';
import { go } from '../../routes';
import { getToken } from 'libs/newHttp';

class BookingPageMobile extends Component {
  static propTypes = {
    getPracticeProfile: PropTypes.func.isRequired,
    selectTime: PropTypes.func.isRequired,
    filterMorning: PropTypes.func.isRequired,
    filterAfternoon: PropTypes.func.isRequired,
    filterEvening: PropTypes.func.isRequired,
    selectDay: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    doctors: PropTypes.arrayOf(DoctorProfilePropType).isRequired,
    selectedTime: SelectedTimePropType,
    goToDoctorProfile: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    clearPracticeBookingPageReducerState: PropTypes.func.isRequired,
    practiceName: PropTypes.string,
    onTimeSelectedFn: PropTypes.func,
    setDateTimePickerIsShowing: PropTypes.func.isRequired,
    availableDoctors: PropTypes.arrayOf(DoctorProfilePropType),
    practice: PropTypes.object,
    patientDetails: PropTypes.object,
    guardianDetails: PropTypes.object,
    token: PropTypes.string,
  };

  state = {
    filteredDoctors: this.props.doctors,
  };

  componentDidMount() {
    const token = getToken();

    if (token) {
      this.props.getProfile(token);
    }
    this.props.getPracticeProfile(this.props.match.params.id);

    // eslint-disable-next-line react/no-find-dom-node
    if (
      !this.props.onTimeSelectedFn &&
      this.props.selectedTime &&
      !this.props.practice?.MustLoginBeforeBooking
    ) {
      this.props.clearAppointmentData();
    }

    ReactDOM.findDOMNode(this.container).addEventListener(
      'click',
      this.setDateTimePickerIsShowing,
      false,
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.practiceName &&
      nextProps.practiceName.length > 1 &&
      document.title !== nextProps.practiceName
    ) {
      document.title = nextProps.practiceName;
    }

    if (nextProps.doctors !== this.props.doctors) {
      this.setState({ filteredDoctors: nextProps.doctors });
      this.filterDoctors(0, nextProps.doctors);
    }
  }
  
  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.clearPracticeBookingPageReducerState();
  }

  getNextAvailable = () => {
    compose(
      min,
      map(d => d?.NextAvailableSlot),
    )(this.props.availableDoctors);
  };

  setDateTimePickerIsShowing = () => {
    this.props.setDateTimePickerIsShowing(false);
  };

  setTime = (doctorId, appointmentId, time, sessionId) => {
    this.props.selectTime(doctorId, appointmentId, time);
    if (!this.props.practice.MustLoginBeforeBooking) {
      if (this.props.onTimeSelectedFn) {
        this.props.onTimeSelectedFn(doctorId, appointmentId, time);
      } else if (this.props.isLoggedIn) {
        go.patientSelection(this.props.url);
      } else {
        go.loginTriage(this.props.url);
      }
    } else {
      if (this.props.onTimeSelectedFn) {
        this.props.onTimeSelectedFn(doctorId, appointmentId, time);
      } else {
        this.props.fillSession(
          this.props.practice.UrlName,
          this.props.practice.Id,
          sessionId,
          doctorId,
          appointmentId,
          time,
        );
        go.reason(this.props.practice.UrlName, true);
      }
    }
  };

  selectDayWrapper = date => {
    if (this.props.practice?.UrlName !== undefined) {
      if (this.props.practice.MustLoginBeforeBooking) {
        if (!this.props.patientDetails.ready) {
          if (this.token !== undefined)
            go.patientSelection(this.props.practice.UrlName);
          else go.practiceProfile(this.props.practice.UrlName);
        }
        this.props.selectDay(
          this.props.practice.UrlName,
          date,
          'first',
          'flu',
          {
            FirstName: this.props.patientDetails.patientDetails?.firstName,
            LastName: this.props.patientDetails.patientDetails?.lastName,
            DateOfBirth: this.props.patientDetails.patientDetails?.dateOfBirth,
            Mobile: this.props.patientDetails.patientDetails?.mobile,
            DependantId: this.props.patientDetails.patientDetails?.dependantId,
            InitiatorFirstName: this.props.guardianDetails.firstName,
            InitiatorLastName: this.props.guardianDetails.lastName,
            InitiatorDateOfBirth: this.props.guardianDetails.dateOfBirth,
            InitiatorMobile: this.props.guardianDetails.mobile,
          },
          this.props.token,
        );
      } else {
        this.props.selectDay(
          this.props.practice.UrlName,
          date,
          'first',
          'flu',
          null,
          this.props.token,
        );
      }
    }
  };

  goToDate = date => () => {
    const hourOfDay = moment(date).hour();
    if (hourOfDay < 12) {
      this.props.filterMorning();
    } else if (hourOfDay < 17) {
      this.props.filterAfternoon();
    } else {
      this.props.filterEvening();
    }
    if (
      this.props.practice.MustLoginBeforeBooking &&
      !this.props.patientDetails.ready
    ) {
      go.practiceProfile(this.props.practice.UrlName);
    }
    this.selectDayWrapper(moment(date));
  };

  serviceSelected = service => {
    this.filterDoctors(service?.Id ?? 0);
  };

  filterDoctors = (serviceId, doctors = this.props.doctors) => {
    let filteredDoctors;

    if (!serviceId || serviceId == 0) {
      filteredDoctors = doctors;
    } else {
      filteredDoctors = doctors.filter(d => d.Services.includes(serviceId));
    }

    this.setState({ filteredDoctors });
  };

  render() {
    const orgId = this.props.match.params.id;
    const emptyBookings = this.props.doctors.length === 0;
    this.getNextAvailable();
    return (
      <div style={{ overflow: 'scroll' }}>
        <Header
          firstLine={this.props.practiceName}
          secondLine={
            <DatePickerComponent
              practiceUrlName={this.props.match.params.id}
              serviceSelected={this.serviceSelected}
              selectDay={this.selectDayWrapper}
            />
          }
          headerClassNames={styles.bookingHeading}
          showHelp
          showCross={!this.props.practice.MustLoginBeforeBooking}
          hideArrow={!this.props.practice.MustLoginBeforeBooking}
          goBackFn={() =>
            this.props.practice.MustLoginBeforeBooking
              ? this.props.token
                ? go.patientSelection(this.props.practice.UrlName)
                : go.practiceProfile(this.props.practice.UrlName)
              : go.home()
          }
        />
        <LoadingSpinner
          isFetching={this.props.isFetching}
          iconClassName={styles.icon}
          containerClassName={styles.page}
          contentRef={c => {
            this.container = c;
          }}
          onClick={() => this.props.setDateTimePickerIsShowing(false)}
        >
          {!this.props.isFetching && (emptyBookings || !this.props.online) ? (
            <EmptyBookings
              online={this.props.online}
              goToDate={this.goToDate}
              nextAvailable={this.getNextAvailable()}
            />
          ) : (
            map(
              d => (
                <DoctorContainer
                  selectedTime={this.props.selectedTime}
                  doctor={d}
                  setTime={this.setTime}
                  key={d.PmsUserId}
                  onClick={this.props.goToDoctorProfile(orgId, d.PmsUserId)}
                  goToDate={this.goToDate}
                  currentFilter={this.props.currentFilter.toLowerCase()}
                  morning={this.props.hasMorning}
                  afternoon={this.props.hasAfternoon}
                  evening={this.props.hasEvening}
                  filterMorning={this.props.filterMorning}
                  filterAfternoon={this.props.filterAfternoon}
                  filterEvening={this.props.filterEvening}
                />
              ),
              this.state.filteredDoctors,
            )
          )}
        </LoadingSpinner>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  onTimeSelectedFn: state.practiceBookingPageReducer.onTimeSelectedFn,
  isLoggedIn: state.loginReducer.token !== null,
  selectedTime: state.practiceAppointmentReducer.selectedTime,
  currentFilter: state.practiceAppointmentReducer.currentFilter,
  isFetching: state.practiceAppointmentReducer.doctorInfo.isFetching,
  practice: state.practiceProfileReducer.profile,
  practiceName: state.practiceProfileReducer.profile.Name,
  url: state.practiceProfileReducer.profile.UrlName,
  online: state.practiceProfileReducer.profile.IsOnline,
  availableDoctors: state.practiceAppointmentReducer.doctorInfo.doctors,
  hasMorning:
    state.practiceAppointmentReducer.days.first.hasMorningAppointments,
  hasAfternoon:
    state.practiceAppointmentReducer.days.first.hasAfternoonAppointments,
  hasEvening:
    state.practiceAppointmentReducer.days.first.hasEveningAppointments,
  doctors: (() => {
    switch (state.practiceAppointmentReducer.currentFilter) {
      case filterTypes.morning:
        return state.practiceAppointmentReducer.days.first.morningAppointments;
      case filterTypes.afternoon:
        return state.practiceAppointmentReducer.days.first
          .afternoonAppointments;
      case filterTypes.evening:
        return state.practiceAppointmentReducer.days.first.eveningAppointments;
      default:
        return state.practiceAppointmentReducer.days.first.morningAppointments;
    }
  })(),
  token: state.loginReducer.token,
  patientDetails: state.patientDetailsReducer,
  guardianDetails: state.guardianDetailsReducer,
});
const mapDispatchToProps = dispatch => ({
  selectTime: bindActionCreators(appointmentActions.selectTime, dispatch),
  getPracticeProfile: bindActionCreators(
    practiceActions.getPracticeProfile,
    dispatch,
  ),
  clearPracticeBookingPageReducerState: bindActionCreators(
    pageActions.clearState,
    dispatch,
  ),
  setDateTimePickerIsShowing: bindActionCreators(
    pageActions.setDateTimePickerIsShowing,
    dispatch,
  ),
  filterMorning: bindActionCreators(filterActions.filterMorning, dispatch),
  clearAppointmentData: clearAppointmentData(dispatch),
  filterAfternoon: bindActionCreators(filterActions.filterAfternoon, dispatch),
  filterEvening: bindActionCreators(filterActions.filterEvening, dispatch),
  selectDay: bindActionCreators(appointmentActions.selectDay, dispatch),
  // eslint-disable-next-line max-len
  goToDoctorProfile: (orgId, id) => () => go.doctorProfile(orgId, id),
  getProfile: bindActionCreators(profileActions.getProfile, dispatch),
  fillSession: bindActionCreators(
    patientSelectionActions.fillSession,
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingPageMobile);
